import { render, staticRenderFns } from "./promotionTab.vue?vue&type=template&id=0a3ac0f5&scoped=true&lang=pug"
import script from "./promotionTab.vue?vue&type=script&lang=js"
export * from "./promotionTab.vue?vue&type=script&lang=js"
import style0 from "./promotionTab.vue?vue&type=style&index=0&id=0a3ac0f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3ac0f5",
  null
  
)

export default component.exports